<template>
  <div class="editable-cell">
    <div v-if="editable" class="editable-cell-input-wrapper">
      <Input
        type="number"
        inputmode="numeric"
        :showLabel="false"
        placeholder="0"
        size="small"
        :value="value"
        :min="0"
        @change="handleChange"
        @pressEnter="check"
        :formItem="{ colon: false, width: '100%' }"
        :style="{ width: '100% !important' }"
      />
      <a-icon type="check" class="editable-cell-icon-check" @click="check" />
    </div>
    <div v-else class="editable-cell-text-wrapper">
      {{ (value || 0) | formatNumber }}
      <a-icon type="edit" class="editable-cell-icon" @click="edit" />
    </div>
  </div>
</template>
<script>
import Input from "@/components/core/VeeValidateForm/Input";
import { formatNumber } from "accounting";

export default {
  name: "EditableCell",
  components: {
    Input,
  },
  props: {
    modelValue: Number,
  },
  filters: {
    formatNumber(value) {
      return formatNumber(value, 2, ",", ".");
    },
  },
  data() {
    return {
      value: this.modelValue,
      editable: false,
    };
  },
  methods: {
    handleChange(e) {
      const value = e?.target?.value || e;
      this.value = value;
    },
    check() {
      if (this.value <= 0) {
        this.$message.error("El valor no puede ser menor o igual a 0");
        return;
      }
      this.editable = false;
      this.$emit("change", this.value);
    },
    edit() {
      this.editable = true;
    },
  },
  watch: {
    modelValue: {
      handler(value, old) {
        if (value === old) return;
        this.value = value;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.editable-cell {
  position: relative;
  width: 100%;
  &-text-wrapper {
    padding-right: 24px;
  }
  &-input-wrapper {
    padding: 0 24px 0 5px;
  }
  &-text-wrapper {
    padding: 5px 24px 5px 5px;
  }
  &-icon,
  &-icon-check {
    position: absolute;
    right: 0;
    cursor: pointer;
    color: var(--link);
  }
  &-icon {
    line-height: 25px;
  }
  &-icon-check {
    line-height: 28px;
  }
  ::v-deep .ant-form-item {
    margin-bottom: 0;
  }
  ::v-deep .editable-cell-input-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 5px;
  }
}
</style>
